import { render, staticRenderFns } from "./generaciones-registro.vue?vue&type=template&id=126b452b&"
import script from "./generaciones-registro.component.ts?vue&type=script&lang=ts&"
export * from "./generaciones-registro.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports